import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import { Row } from '../../Resources';

import { loadFilters } from 'components/Filter/store/thunk';

export default function NfseUpdate({ data, lastRegister, newRegister }) {
  const dispatch = useDispatch();

  const { establishmentId, observation, createdAt } = data;

  const oldConfigs = !!lastRegister?.automaticGenerateNfse ? JSON.parse(lastRegister?.automaticGenerateNfse) : {};
  const newConfigs = !!newRegister?.automaticGenerateNfse ? JSON.parse(newRegister?.automaticGenerateNfse) : {};

  const { userId } = useSelector(state => state.profile);
  const { selects } = useSelector(state => state.filters);

  const paymentMethods = selects
    ?.find(filter => filter?.id == 'paymentMethod')
    ?.options;

  useEffect(() => {
    if(establishmentId) {
      dispatch(loadFilters(userId, establishmentId));
    }
  }, [establishmentId]);

  return(
    <Grid container>
      <Grid xs={12}>
        {!!observation ? (
          <Typography color='primary'>
            {observation} em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
          </Typography>
        ) : (
          <Typography color='primary'>
            Atualização em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
          </Typography>
        )}
      </Grid>
      <Grid xs={12} style={{ padding: 5 }}>
        <Typography color='primary' style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
          <b>Configuração Anterior</b>
        </Typography>
        <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
          {Object.keys(oldConfigs).includes('serviceOrders') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as ordens de serviços pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+oldConfigs?.serviceOrders == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.keys(oldConfigs).includes('invoices') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as faturas de cliente pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+oldConfigs?.invoices == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.keys(oldConfigs).includes('selectedTransactions') && (
            <Row>
              <Typography color='primary'>
                <b>Emissão quando solicitada a nota fiscal</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+oldConfigs?.selectedTransactions == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.keys(oldConfigs).includes('paymentMethods') && (
            <Row>
              <Typography color='primary'>
                <b>Meios de pagamento</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {paymentMethods?.filter(paymentMethod => oldConfigs?.paymentMethods?.includes(+paymentMethod?.value))?.map(paymentMethod => paymentMethod?.label)?.join(', ') || '--'}
              </Typography>
            </Row>
          )}
          {Object.keys(lastRegister).includes('statusRps') && (
            <Row>
              <Typography color='primary'>
                <b>Status</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+lastRegister?.statusRps == 0 ? 'Desativado' : 'Ativado'}
              </Typography>
            </Row>
          )}
          {Object.keys(lastRegister).includes('automaticSendNfse') && (
            <Row>
              <Typography color='primary'>
                <b>Envio automático de notas fiscais</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+lastRegister?.automaticSendNfse == 0 ? 'Desativado' : 'Ativado'}
              </Typography>
            </Row>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ padding: 5 }}>
        <Typography color='primary' style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
          <b>Configuração Atual</b>
        </Typography>
        <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
          {Object.keys(newConfigs).includes('serviceOrders') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as ordens de serviços pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newConfigs?.serviceOrders == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.keys(newConfigs).includes('invoices') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as faturas de cliente pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newConfigs?.invoices == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.keys(newConfigs).includes('selectedTransactions') && (
            <Row>
              <Typography color='primary'>
                <b>Emissão quando solicitada a nota fiscal</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newConfigs?.selectedTransactions == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.keys(newConfigs).includes('paymentMethods') && (
            <Row>
              <Typography color='primary'>
                <b>Meios de pagamento</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {paymentMethods?.filter(paymentMethod => newConfigs?.paymentMethods?.includes(+paymentMethod?.value))?.map(paymentMethod => paymentMethod?.label)?.join(', ') || '--'}
              </Typography>
            </Row>
          )}
          {Object.keys(newRegister).includes('statusRps') && (
            <Row>
              <Typography color='primary'>
                <b>Status</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newRegister?.statusRps == 0 ? 'Desativado' : 'Ativado'}
              </Typography>
            </Row>
          )}
          {Object.keys(newRegister).includes('automaticSendNfse') && (
            <Row>
              <Typography color='primary'>
                <b>Envio automático de notas fiscais</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newRegister?.automaticSendNfse == 0 ? 'Desativado' : 'Ativado'}
              </Typography>
            </Row>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}